(ns app.front.view.admin.subs
  (:require [clojure.string :as str]
            [re-frame.core-instrumented :as rf]))

;; Subs

(rf/reg-sub
  ::dialogs
  (fn [db _]
    (-> db
        (select-keys [:new-group :add-user :new-municipality]))))


(rf/reg-sub
  ::dialog-data
  :<- [::dialogs]
  (fn [data [_ & path]]
    (get-in data (vec path))))

;; Events

(rf/reg-event-db
  ::dialog-open
  (fn [db [_ k data]]
    (assoc db k (-> (assoc data :open? true)
                    (update :disabled? (fnil identity false))))))

(rf/reg-event-fx
  ::dialog-edit
  (fn [{db :db} [_ k field v]]
    {:db (assoc-in db [k field] (cond-> v
                                  (string? v) str/trim))}))

(rf/reg-event-db
  ::dialog-close
  (fn [db [_ k]]
    (dissoc db k)))
